export default __webpack_public_path__ + "static/media/agendaCultural.74ec3fd4.png";